<template>
    <div>
      <TransitionRoot appear :show="isMessageOpen" @close="closeSignatureModal" as="template">
        <Dialog as="div">
          <div class="fixed inset-0 z-10 overflow-y-auto">
            <div class="min-h-screen px-4 text-center">
              <TransitionChild
                as="template"
                enter="duration-300 ease-out"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="duration-200 ease-in"
                leave-from="opacity-100"
                leave-to="opacity-0"
              >
                <DialogOverlay class="fixed inset-0 bg-black opacity-70" />
              </TransitionChild>
  
              <span class="inline-block h-screen align-middle" aria-hidden="true">
                &#8203;
              </span>
  
              <TransitionChild
                as="template"
                enter="duration-300 ease-out"
                enter-from="opacity-0 scale-95"
                enter-to="opacity-100 scale-100"
                leave="duration-200 ease-in"
                leave-from="opacity-100 scale-100"
                leave-to="opacity-0 scale-95"
              >
                <div
                  class="inline-block border w-full max-w-4xl p-6 my-6 overflow-hidden text-left align-middle transition-all transform bg-white shadow-2xl"
                >
                  <DialogTitle
                    as="h4"
                    class="text-size font-medium leading-6 text-gray-600"
                  >
                    Signature Pad <span class=" text-size-sm text-emerald-600">(Sign Below)</span>
                  </DialogTitle>
                  <div class="my-1">
                    <vue3Signature
                      ref="signature"
                      :sigOption="option"
                      :w="'800px'"
                      :h="'256px'"
                      :disabled="disabled"
                      class="touch-none"
                    />
                  </div>
  
                  <div class="mt-2 flex justify-center space-x-0.5">
                    <button
                      type="button"
                      class=" items-center inline-flex justify-center px-4 py-1 text-size-sm text-emerald-900 bg-gray-300 border
                              border-transparent hover:bg-emerald-600 hover:opacity-90 hover:text-white focus:outline-none focus-visible:ring-2
                              focus-visible:ring-offset-2 focus-visible:ring-white"
                      @click="closeSignatureModal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      class=" items-center inline-flex justify-center px-4 py-1 text-size-sm text-emerald-900 bg-gray-300 border
                              border-transparent hover:bg-emerald-600 hover:opacity-90 hover:text-white focus:outline-none focus-visible:ring-2
                              focus-visible:ring-offset-2 focus-visible:ring-white"
                      @click="clearSignature()"
                    >
                      Clear
                    </button>
                    <button
                      type="button"
                      class=" items-center inline-flex justify-center px-4 py-1 text-size-sm text-emerald-900 bg-gray-300 border
                              border-transparent hover:bg-emerald-600 hover:opacity-90 hover:text-white focus:outline-none focus-visible:ring-2
                              focus-visible:ring-offset-2 focus-visible:ring-white"
                      @click="submit()"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </TransitionChild>
            </div>
          </div>
        </Dialog>
      </TransitionRoot>
    </div>
  </template>
  
  <script>
  import { ref } from 'vue'
  import vue3Signature from "vue3-signature";
  import { TransitionRoot, TransitionChild, Dialog, DialogOverlay } from '@headlessui/vue'
  
  export default {
    components: {
      TransitionRoot,
      TransitionChild,
      Dialog,
      DialogOverlay,
      vue3Signature
      // DialogTitle
    },
    setup () {
      const isMessageOpen = ref(false)
      return {
        isMessageOpen,
        closeSignatureModal () {
          isMessageOpen.value = false
        },
        openSignatureModal () {
          isMessageOpen.value = true
        }
      }
    },
    name: 'message-modal',
    props: {
    },
    data: () => {
      return {
        base64String: null
      }
    },
    methods: {
      emitEvent () {
        this.$emit('base64', this.base64String)
      },
      // submit base 64 signature
      submit () {
        // get the base64 and emit the event
        const isEmpty = this.$refs.signature.isEmpty()
        if (!isEmpty) {
          this.base64String = this.$refs.signature.save()
          this.emitEvent()

          // close the modal
          this.closeSignatureModal()
        }
      },
      // removes the signature
      clearSignature () {
        this.$refs.signature.clear()
      },
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style >
  </style>
  